"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultDaytimeWakeTime = exports.defaultDaytimeSleepTime = exports.defaultWakeTime = exports.defaultSleepTime = exports.daytimeActivityRatings = exports.sleepRatings = void 0;
exports.sleepRatings = [
    { id: 1, label: 'sleepDiary.rating.1' },
    { id: 2, label: 'sleepDiary.rating.2' },
    { id: 3, label: 'sleepDiary.rating.3' },
    { id: 4, label: 'sleepDiary.rating.4' },
    { id: 5, label: 'sleepDiary.rating.5' },
];
exports.daytimeActivityRatings = [
    { id: 1, label: 'sleepDiary.activityRating.veryLow' },
    { id: 2, label: 'sleepDiary.activityRating.low' },
    { id: 3, label: 'sleepDiary.activityRating.medium' },
    { id: 4, label: 'sleepDiary.activityRating.some' },
    { id: 5, label: 'sleepDiary.activityRating.very' },
];
exports.defaultSleepTime = '22:00';
exports.defaultWakeTime = '07:00';
exports.defaultDaytimeSleepTime = '13:00';
exports.defaultDaytimeWakeTime = '13:30';
